import { getAxiosClient } from './common';

const axios = getAxiosClient();

export interface ReportProblemBody {
  description: string;
  screenshotBase64: string;
  coords: { lng: number; lat: number; zoom: number };
  projectId: string;
  projectLink: string;
  layers: string[];
  posthogSessionUrl: string | null;
  metadata: Record<string, unknown>;
}

export interface ReportProblemResult {
  issueUrl: string;
  issueIdentifier: string;
}

export async function reportProblem(body: ReportProblemBody): Promise<ReportProblemResult> {
  const { data } = await axios({
    method: 'POST',
    url: '/v1/reportProblem',
    data: body,
  });

  return data;
}
